module.exports = __webpack_public_path__ + "img/NoImage.933e71cd.jpg";